<app-agricola-navbar></app-agricola-navbar>

<app-agricola-toast
  [message]="toastMessage"
  [type]="toastType"
  [show]="showToast"
  (close)="hideToast()">
</app-agricola-toast>

<div class="consultas-page">

  <!-- Search card: back + header + form -->
  <div class="search-card consultas-card">

    <button class="back-btn" (click)="goBack()" type="button">
      <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" class="back-icon">
        <path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Atras
    </button>

    <div class="page-header">
      <h1 class="page-title">Consultas</h1>
      <p class="page-subtitle">Ingrese los datos requeridos para realizar la consulta</p>
    </div>

    <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="search-form">

      <div class="form-field">
        <label class="field-label" for="searchType">Tipo de búsqueda</label>
        <div class="select-wrapper">
          <select id="searchType" formControlName="searchType" class="field-select">
            <option *ngFor="let st of searchTypes" [value]="st.value">{{ st.label }}</option>
          </select>
          <svg class="select-arrow" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M5 7l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <div class="form-field">
        <label class="field-label" for="searchValue">Valor de búsqueda</label>
        <input
          id="searchValue"
          type="text"
          formControlName="searchValue"
          class="field-input"
          placeholder="Ingresa el valor a buscar"
          [disabled]="isLoading">
      </div>

      <button
        type="submit"
        class="search-button"
        [disabled]="searchForm.invalid || isLoading">
        {{ isLoading ? 'BUSCANDO...' : 'Buscar' }}
      </button>
    </form>
  </div>

  <!-- Results card: title + table -->
  <div class="results-card consultas-card" *ngIf="hasSearched">

    <!-- Results header -->
    <div class="results-header">
      <h2 class="results-title">Resultados de busqueda</h2>
      <p class="results-subtitle">Número total de negocios</p>
    </div>

    <!-- Table toolbar with pagination controls -->
    <div class="table-toolbar">
      <span class="toolbar-label">Resultados de busqueda</span>
      <div class="pagination-controls">
        <span class="movements-label">{{ movementsLabel }}</span>

        <button class="page-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1" aria-label="Página anterior">
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <button
          *ngFor="let page of visiblePages"
          class="page-btn"
          [class.page-btn--active]="page === currentPage"
          (click)="goToPage(page)"
          [attr.aria-current]="page === currentPage ? 'page' : null">
          {{ page }}
        </button>

        <button class="page-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages" aria-label="Página siguiente">
          <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <div class="page-size-wrapper">
          <select class="page-size-select" [value]="pageSize" (change)="onPageSizeChange($event)" aria-label="Registros por página">
            <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option>
          </select>
          <svg class="select-arrow" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M5 7l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Estado de Poliza/Solicitud - Certificado</th>
            <th>N° de Poliza/Solicitud - Certificado</th>
            <th>Nombre del cliente</th>
            <th>Tipo de producto</th>
            <th>Código producto</th>
            <th>Nombre producto</th>
            <th>Suma asegurada</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of pagedResults"
            class="table-row"
            (click)="onRowClick(item)"
            tabindex="0"
            (keydown.enter)="onRowClick(item)"
            aria-label="Ver detalle de póliza {{ item.policyNumber }}">
            <td>{{ item.status }}</td>
            <td>{{ item.policyNumber }}</td>
            <td>{{ item.clientName }}</td>
            <td>{{ item.productType }}</td>
            <td>{{ item.productCode }}</td>
            <td>{{ item.productName }}</td>
            <td>{{ item.currencySymbol }} {{ item.insuredAmount | number:'1.2-2' }}</td>
            <td class="row-chevron">
              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p *ngIf="!isLoading && pagedResults.length === 0" class="empty-state">No se encontraron resultados para los criterios ingresados.</p>

  </div>
</div>
